// @flow
/**
 */
class ModularUIError extends Error {
  response: Object;
  resource: string;

  /**
   */
  constructor(message: string, response: Object, resource: string) {
    super(message);

    this.response = response;
    this.resource = resource;

    // Without passing ModularUIError to captureStackTrace, the ModularUIError
    // frame would show up in the .stack property. By passing
    // the constructor, we omit that frame, and retain all frames below it.
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, ModularUIError);
    }
  }
}

export default ModularUIError;
